<script>
import toPairs from "lodash/toPairs";
export default {
  props: {
    propData: Object,
    iconSize: Number,
    trainCounts: Number
  },
  data() {
    const trainCounts = toPairs(this.propData.gameTrack).length;
    // console.log("-trainCounts->>>", this.trainCounts, this.propData);
    return {
      counts: trainCounts > 0 ? trainCounts : 4,
      showBonusScene: false,
      data: toPairs(this.propData.gameTrack)
    };
  },
  computed: {
    style() {
      const size = this.iconSize || 14;
      return {
        "font-size": `${size}px`,
        "line-height": "20px"
      };
    },
    styleStatus() {
      return {
        color: `#D8D8D8`
      };
    }
  }
  // created() {
  //   this.init();
  // },
  // methods: {
  //   init() {
  //     console.log("this.", this.trainCounts);
  //   }
  // }
};
</script>

<template>
  <div class="statusContent">
    <el-row class="el-row">
      <el-col
        v-for="(key, index) in data"
        :key="`${key[1].trainingId}_` + index"
        class="trainStatus"
        :span="6"
      >
        <div v-if="key[1].trainingState === 'PENDING'" class="game-content" :style="styleStatus">
          <div :style="style">
            <span>{{key[1].gameLabel}}</span>
          </div>
          <div :style="style">
            <span>{{key[1].gameName}}</span>
          </div>
          <div>
            评估值：--
            <!-- <gameRateStar v-if="key[1].trainingId" class="gameRateStar" :score="0" /> -->
          </div>
        </div>
        <div v-else class="game-content">
          <div :style="style">
            <span>{{key[1].gameLabel}}</span>
          </div>
          <div :style="style">
            <span>{{key[1].gameName}}</span>
          </div>
          <div>
            评估值：
            <span v-if="key[1].quality && key[1].quality >= 25">{{key[1].quality}}</span>
            <span
              v-else-if="key[1].quality && key[1].quality >= 10"
              style="color: #FFB200"
            >{{key[1].quality}}</span>
            <span
              v-else-if="key[1].quality && key[1].quality < 10"
              style="color: #FF0000"
            >{{key[1].quality}}</span>
            <span style="color: #FF0000" v-else-if="key[1].quality== 0">{{key[1].quality}}</span>
            <span v-else>--</span>
            <!-- <gameRateStar v-if="key[1].trainingId" class="gameRateStar" :score="key[1].score" /> -->
          </div>
        </div>
        <div v-if="index +1  !== counts && counts !== 1" class="line"></div>
      </el-col>
    </el-row>
  </div>
</template>

<style lang="scss">
.statusContent {
  display: flex;
  flex-grow: 1;
  .el-row {
    width: 100%;
  }
  .trainStatus {
    margin: auto;
    display: flex;
    justify-content: flex-start;
    flex-shrink: 1;
    flex-grow: 1;
    .game-content {
      flex-shrink: 1;
      flex-grow: 1;
    }
    .star {
      display: inline-block;
      width: 20px;
      height: 20px;
    }
    .line {
      width: 1px;
      background-color: #e4e8eb;
      height: 40px;
      margin: auto 15% auto auto;
      display: inline-block;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/visionTrainTrack/trainStatus.vue